import { fromCents } from '#src/lib/formatters/numbers.js';

import { getBillingDateString } from './get-billing-date-string.js';
import { hasTrial } from './has-trial.js';

export function getRebillString(subscription) {
  if (!subscription?.amount) {
    return null;
  }
  const amt = fromCents(subscription.amount);
  const date = getBillingDateString(subscription);
  const trialText = hasTrial(subscription) ? 'unless cancelled beforehand' : '';
  return `${amt} billed on ${date} ${trialText}`;
}
